import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'wk8-button',
  imports: [],
  templateUrl: './wk8-button.component.html',
  styleUrl: './wk8-button.component.css',
})
export class Wk8ButtonComponent {
  // INPUTS
  color = input<'green' | 'orange' | 'blue' | 'gray-circle' | 'blue-circle'>('orange');
  icon = input<'up-down-arrows' | 'right-arrow' | 'checkmark' | 'squiggle' | 'info' | 'reset'>('up-down-arrows');
  disabled = input(false);
  clicked = output();

  backgroundPath = computed(() => {
    switch (this.color()) {
      case 'green':
        return `${this.assetPath}green-square-button.png`;
      case 'orange':
        return `${this.assetPath}orange-square-button.png`;
      case 'blue':
        return `${this.assetPath}blue-square-button.png`;
      case 'gray-circle':
        return `${this.assetPath}gray-circle-button.png`;
      case 'blue-circle':
        return `${this.assetPath}blue-circle-button.png`;
      default:
        throw new Error(`Unknown color: ${this.color()}`);
    }
  });
  iconPath = computed(() => {
    switch (this.icon()) {
      case 'right-arrow':
        return `${this.assetPath}right-arrow.png`;
      case 'up-down-arrows':
        return `${this.assetPath}up-down-arrows.png`;
      case 'checkmark':
        return `${this.assetPath}checkmark.png`;
      case 'squiggle':
        return `${this.assetPath}squiggle.png`;
      case 'info':
        return `${this.assetPath}info.png`;
      case 'reset':
        return `${this.assetPath}reset.png`;
      default:
        throw new Error(`Unknown icon: ${this.icon()}`);
    }
  });

  readonly assetPath = 'assets/woordkr8/sprites/';
}
